import {
  StatementEditorV2IndexNode,
  StatementEditorV2ContentDataType,
  StatementEditorV2ContentDataTypeWithPosition,
} from './types'

function buildContentPositionMap(indexData: StatementEditorV2IndexNode[]): Record<string, string[]> {
  const contentPositionMap: Record<string, string[]> = {}

  function traverseIndex(node: StatementEditorV2IndexNode, positionPath: string[] = []): void {
    const currentPath = [...positionPath, node.title]

    if (node.contentRefs) {
      node.contentRefs.forEach((contentId) => {
        contentPositionMap[contentId] = currentPath
      })
    }

    if (node.children) {
      node.children.forEach((child) => {
        traverseIndex(child, currentPath)
      })
    }
  }

  indexData.forEach((chapter) => {
    traverseIndex(chapter)
  })

  return contentPositionMap
}

export function addPositionToContentBlocks(
  contentBlocks: StatementEditorV2ContentDataType[],
  indexData: StatementEditorV2IndexNode[]
): StatementEditorV2ContentDataTypeWithPosition[] {
  const contentPositionMap = buildContentPositionMap(indexData)

  return contentBlocks.map((content) => {
    const existingPosition = (content as StatementEditorV2ContentDataTypeWithPosition).position
    const position = Array.isArray(existingPosition) ? existingPosition : contentPositionMap[content.id] || []

    return {
      ...content,
      position,
    } as StatementEditorV2ContentDataTypeWithPosition
  })
}
